export const PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS = {
	onboardingActionStates: 'personalized-templates-v2:onboardingActionStates',
	hasDismissedOnboardingActions: 'personalized-templates-v2:hasDismissedOnboardingActions',
	takeoverSeenAt: 'personalized-templates-v2:takeoverSeenAt',
	isTemplateListDismissed: 'personalized-templates-v2:isTemplateListDismissed',
	templateUsageValues: 'personalized-templates-v2:templateUsageValues',
} as const;

export const PersonalizedTemplatesOnboardingKeys = [
	...Object.values(PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS),
] as const;
